module.exports = __webpack_public_path__ + "media/images/md-logo-wt-033304fc47be277513acf7f0c9a315d7095066bf2b61031e6c30f122f02fb155.svg";